import React, { Component } from 'react';
import './KPI1.css';

// publication_date - orbit.anx_date_time

// product filter => publication_date OLD
// product filter => orbit.anx_date_time

import Select from '@acri-tools/react-tools/components/Select/Select';
import KPIs from '../KPIs';
import * as Chart from 'chart.js';
import { Scatter } from 'react-chartjs-2';

import DATA from './data';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { getDateString, getDateTimeString } from '@acri-tools/react-tools/utils/date';

import moment, { duration } from 'moment';
// import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import { horizonalLinePlugin } from '../../../_utils/graphs';
import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import KPITable from '../../../components/KPITable/KPITable';
import { connect } from 'react-redux';
import { date_timezone_compensated, get_kpi_product_type, get_month_dates, is_on_kpi_page, update_kpi_url } from '../../../_utils/kpi';
import classNames from 'classnames';
import { API_URL, axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';
import { get_default_product_type, get_product_type_id, load_product_types } from '../../../_utils/product_types';
import { get_date_difference, to_local_iso_string } from '../../../_utils/date';
import KPIRefreshOverlay from '../../../components/KPIRefreshOverlay/KPIRefreshOverlay';



Chart.plugins.register(zoomPlugin);
Chart.plugins.register(horizonalLinePlugin);

interface Props {
    // REDUX
    product_types?:any
    kpi?:any
}
interface State {
    refreshing: boolean
    loading: boolean

    mode: string
    productType: string
    base_productType: string

    startDate: string
    stopDate: string
    updateStartDate: string
    updateStopDate: string
    base_startDate?: string
    base_stopDate?: string

    data?:any

    nominalTimeliness?: number
    
    drag_mode: boolean

    // export
    json_format: boolean
}

/**
 * KPI ->
 * LIST produt type / ( FORMAT /) mode / kpi (real time)
 * product type / mode / start / stop => Graph / List with list of  values used for KPI (duration) session.stop / product.generation_date
 * BONUS : Select multi product_types
 */



const DATE_FILTER = 'session.stop_date_time';
//  const DATE_FILTER = 'start_date_time';
//  const DATE_FILTER = 'generation_date_time';

class KPI1 extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        
        this.state = {
            refreshing: false,
            loading: false,
            json_format: false,
            drag_mode: false,
            ...this.default_values(true)
        }
    }

    default_values = (set_base?:boolean) => {
        return {
            mode: 'NRT',
            // productType: get_default_product_type(),
            ...get_kpi_product_type(this.state, set_base, true),
            ...get_month_dates( this.state, set_base )
            // startDate: `${today.getFullYear()}-${today.getMonth().toString().padStart(2, '0')}-01T00:00:00`,
            // stopDate: getDateTimeString(today, true),
        }
    }

    async componentDidMount() {
        await load_product_types()
        await this.setState({
            ...this.default_values(true)
        })
        this.fetch_data(true)
    }

    async componentDidUpdate(prevProps:Props) {
        if(prevProps.kpi?.refresh !== this.props.kpi?.refresh){
            await this.setState({
                ...this.default_values(true)
            })
            if(is_on_kpi_page(1)){
                this.update_url()
            }
            this.fetch_data(true)
        }
    }

    fetch_data = async(refresh?:boolean) => {
        if(refresh) this.setState({ refreshing: true, loading:true });
        else this.setState({ loading:true });
        try {
            let res = await request(`${API_URL}/api/v1/products`,{
                method:'get',
                params:{
                    limit: 4500,
                    expand: 'session, orbit, kpi_timeliness',
                    // orderby:`${DATE_FILTER} DESC`,
                    filter: `product_type eq '${this.state.productType}'
                        and ${DATE_FILTER} ge '${this.state.startDate}'
                        and ${DATE_FILTER} le '${this.state.stopDate}'
                        and mode eq '${this.state.mode}'
                    `
                }
            })

            
            this.setState({
                data: res.data.value?.map((d:any)=>{
                    return {
                        ...d,
                        duration: get_date_difference(d.publication_date_time ,d.session.stop_date_time)
                    }
                })
            });

            // console.log("data", this.state.data)
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_data'
            })
        }
        finally {
            // this.setState({ loading: false })
            if(refresh) this.setState({ refreshing: false, loading:false  });
            else this.setState({ loading:false });
        }
        try {
            let res = await request(`${API_URL}/api/v1/product_types`,{
                method:'get',
                params:{
                    limit: 4500,
                    expand: 'kpi_timeliness',
                    // orderby:`${DATE_FILTER} DESC`,
                    filter: `name eq '${this.state.productType}'
                    AND kpi_timeliness.timeliness eq '${this.state.mode}'`
                }
            })

            
            this.setState({
                nominalTimeliness: res.data.value[0].kpi_timeliness.nominal
            });
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_data'
            })
        }
        finally {
            // this.setState({ loading: false })
            if(refresh) this.setState({ refreshing: false, loading:false  });
            else this.setState({ loading:false });
        }
    }


    update_url = () =>{
        update_kpi_url(1, {
            startDate: to_local_iso_string(this.state.startDate),
            stopDate: to_local_iso_string(this.state.stopDate),
            productType: this.state.productType,
            mode: this.state.mode
        })
    }
    applyChanges = async() =>{
        await this.setState({
            startDate: this.state.updateStartDate,
            stopDate: this.state.updateStopDate
        })
        this.update_url()
        this.fetch_data()
    }

    reset = async() => {
        await this.setState({
            ...this.default_values()
        })
        this.update_url()
        this.fetch_data(true)
    }

    render() {
        return (
            <KPIs
                title="Production Timeliness - Systematic"
            >
                <div className="row-2">
                    <div className="row-2">
                        <div className="form-field">
                            <label>Select Mode</label>
                            <Select
                                value={this.state.mode}
                                onChange={async(mode: string) => { 
                                    await this.setState({ mode }) 
                                    // await this.setState({ productType }); 
                                    this.update_url()
                                    this.fetch_data(true)
                                }}
                                options={['NRT', 'NTC', 'STC'].map((v) => { return { label: v, value: v } })}
                            />
                        </div>
                        {
                            this.props.product_types?.product_types_filtered &&
                            <div className="form-field">
                                <label>Product Type</label>
                                <Select
                                    search
                                    value={this.state.productType}
                                    onChange={async(productType: any) => { 
                                        await this.setState({ productType }); 
                                        this.update_url()
                                        this.fetch_data(true)
                                    }}
                                    options={Object.keys(this.props.product_types.product_types_filtered).map((pt:any) => { return { label: pt, value: pt } })}
                                />
                            </div>
                        }
                    </div>
                    <div className="row-2">
                        <div className="form-field">
                            <label>Start Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStartDate}
                                onChange={(e) => { this.setState({ updateStartDate: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label>Stop Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStopDate}
                                onChange={(e) => { this.setState({ updateStopDate: e.target.value }) }}
                            />
                        </div>
                    </div>
                </div>

                <div className={
                    classNames({
                        "custom-button small alt inline apply-changes": true,
                        "disabled": !(
                            this.state.updateStartDate !== this.state.startDate
                            || this.state.updateStopDate !== this.state.stopDate
                        )
                    })} 
                    onClick={this.applyChanges}
                >
                    <i className="fas fa-check" /> Apply Changes
                </div>
                
                <div className="custom-button small alt inline" onClick={this.reset}>
                    <i className="fas fa-redo-alt" /> Reset Filters
                </div>
                <br />
                <br />

                {/* RESULTS */}
                <div className="title-3">Results</div>

                <Tabs
                    tabs={[
                        {
                            label: <><i className="fas fa-chart-bar" /> Graph</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <>  
                                        <FormFieldCheckbox
                                            notSolid label="Drag Mode"
                                            value={!!this.state.drag_mode}
                                            onChange={(drag_mode: boolean) => { this.setState({ drag_mode }) }}
                                        />
                                        {
                                            this.state.data &&
                                            <div className="kpi-graph kpi-1-graph">
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <Scatter
                                                    plugins={[ 
                                                        zoomPlugin, 
                                                        // VerticalLinePlugin
                                                    ]}
                                                    options={{
                                                        "horizontalLine": [{
                                                            "y": this.state.nominalTimeliness,
                                                            "style": "rgba(255, 0, 0, .4)",
                                                            "text": "Nominal Timeliness"
                                                        }],
                                                        responsive: true,
                                                        maintainAspectRatio: false,

                                                        scales: {
                                                            xAxes: [{
                                                                type: 'time',
                                                                ticks: {
                                                                    autoSkip: true,
                                                                    maxTicksLimit: 9,
                                                                    maxRotation: 0,
                                                                    minRotation: 0,
                                                                    min: moment(new Date(this.state.startDate)),
                                                                    max: moment(new Date(this.state.stopDate)),
                                                                },
                                                                time: {
                                                                    unit: 'hour',
                                                                    minUnit: 'second',
                                                                    displayFormats: {
                                                                        hour: 'YYYY-MM-DDTHH:mm',
                                                                        second: 'YYYY-MM-DDTHH:mm:ss'
                                                                    },
                                                                },
                                                            }],
                                                            yAxes: [{
                                                                ticks: {
                                                                    min: 0,
                                                                },
                                                                scaleLabel: {
                                                                    display: true,
                                                                    labelString: 'Generation duration (h)',
                                                                    fontFamily: 'sans-serif',
                                                                    fontSize: '14',
                                                                    fontStyle: 'italic'
                                                                }
                                                            }],
                                                        },
                                                        legend: {
                                                            display: true,
                                                            position: 'bottom'
                                                        },
                                                        tooltips: {
                                                            mode: 'point',
                                                            callbacks: {
                                                                title: function (tooltipItems: any, data: any) {
                                                                    return data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].product;
                                                                },
                                                                label: function (tooltipItem: any, data: any) {
                                                                    var label = tooltipItem.value;
                                                                    return `Duration: ${label}H`;
                                                                },
                                                                afterLabel: function (tooltipItem: any, data: any) {
                                                                    var xlabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].x;
                                                                    return `Start time: ${new Date(xlabel).toISOString()}`;
                                                                }
                                                            },
                                                        },
                                                        zoom: {
                                                            enabled: true,
                                                            onZoomComplete: async(e: any) => {
                                                                try {
                                                                    let start = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-1']?.min), true, true);
                                                                    let stop = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-1']?.max), true, true);
                                                                    await this.setState({
                                                                        startDate: start,
                                                                        stopDate: stop,
                                                                        updateStartDate: start,
                                                                        updateStopDate: stop
                                                                    })
                                                                    this.update_url()
                                                                    this.fetch_data()
                                                                }
                                                                catch (e) { }
                                                            },
                                                            drag: this.state.drag_mode,
                                                            wheel: !this.state.drag_mode,
                                                            mode: 'x',
                                                        }
                                                    }}

                                                    data={{
                                                        datasets: [
                                                            {
                                                                label: this.state.productType,
                                                                borderColor: 'rgb(75, 102, 192)',
                                                                data: this.state.data?.map((d: any) => {
                                                                    return {
                                                                        name: d.name,
                                                                        y: d.duration,
                                                                        x: date_timezone_compensated(d.publication_date_time)
                                                                    }
                                                                })
                                                            }
                                                            // {
                                                            //     label: 'Nominal Timeliness',
                                                            //     borderColor: 'rgba(255, 0, 0, .4)',
                                                            //     pointRadius: 0,
                                                            //     fill: true,
                                                            //     data: this.state.data?.map((d: any) => {
                                                            //         return {
                                                            //             y: 0.2,
                                                            //             x: date_timezone_compensated(d.publication_date_time)
                                                            //         }
                                                            //     })
                                                            // }
                                                        ],
                                                    }}
                                                />
                                            </div>
                                        }
                                    </>
                                }

                            </div>
                        },
                        {
                            label: <><i className="fas fa-th-list" /> Data</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <>
                                        {
                                            this.state.data &&
                                            <KPITable title="Production Timeliness" counter={this.state.data.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th>Product</th>
                                                            <th>Downlink Session Stop Date</th>
                                                            <th>Publication Date</th>
                                                            <th>Duration</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.data.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td>{d.product_name}</td>
                                                                    <td>{d.session.stop_date_time}</td>
                                                                    <td>{d.publication_date_time}</td>
                                                                    <td>{d.duration ? `${d.duration}H` : '-'}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }
                                    </>
                                }
                            </div>
                        }
                    ]}
                />


                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a 
                    className={classNames({
                        "custom-button medium inline": true
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }



    download_url = () => {
        let params = [
            'expand=product',
            'export=true',
            `product_type=${this.state.productType}`,
            `start_date=${this.state.startDate}`,
            `stop_date=${this.state.stopDate}`
        ];

        if(this.state.json_format) params.push('format=json');
        
        return `${API_URL}/api/v1/kpi_1?${params.join('&')}`
    }


};

export default connect((state:any)=>{
    return {
        product_types: state.product_types,
        kpi: state.kpi
    }
})(KPI1)